import MUIButton, { ButtonProps } from '@material-ui/core/Button';

export const Button: React.FC<ButtonProps> = ({ children, ...muiProps }) => (
  <MUIButton {...muiProps}>{children}</MUIButton>
);

export default Button;
